import store from '@/core/store'
import { isSecureRoute, isNotSecureRoute, allows } from '@/core/router/utils'

let initialFullPath = null

const serviceOnboarding = (to, from, next) => {
  if (store.getters['auth/isServiceOnboardingStepOne'] && 
      to.name !== 'service-onboarding-step-one'
    ) {  
    return next({ name: 'service-onboarding-step-one' })
  } else if (
      store.getters['auth/isServiceOnboardingStepTwo'] &&
      to.name !== 'service-onboarding-step-two'
    ) {
    return next({ name: 'service-onboarding-step-two' })
  }
  next()
}

const titleSetter = (to, from, next) => {
  if (to && to.meta && to.meta.title) {
    document.title = `${to.meta.title} - Caerus`
  } else {
    document.title = `Caerus`
  }

  next()
}

// Re-prompt keyworkers who have nursery-side (observer) children pre-registered
// against their email but haven't completed the confirm-children wizard.
// Without this, a user who drops off mid-flow stays stuck in a dead-end state
// on subsequent logins — no connection to the provider, nothing on dashboard.
// Let the wizard itself and the pre-wizard setup page through to avoid loops.
//
// Ordering matters: the complete-profile step must run BEFORE the wizard.
// Accepting a child syncs the parent's own profile over the provider's carer
// record, so a parent whose profile step never ran arrives at the provider as
// an empty record (staging incident, 2026-07-01). Redirecting stray
// navigation straight to confirm-children was exactly how that step got
// skipped: any click away from complete-profile landed in the wizard.
const confirmChildren = (to, from, next) => {
  if (!store.getters['auth/userIsLoggedIn']) return next()

  const profileFirst = store.getters['auth/needsToCompleteProfile']

  // Guard every door into the wizard, including the recovery entry points
  // (account-menu link, home banner), not just the forced redirect below.
  if (to.name === 'confirm-children' && profileFirst &&
      store.getters['auth/canRecoverChildren']) {
    return next({ name: 'complete-profile' })
  }

  if (!store.getters['auth/needsToConfirmChildren']) return next()

  const allowed = ['confirm-children', 'complete-profile']
  if (allowed.includes(to.name)) return next()

  return next({ name: profileFirst ? 'complete-profile' : 'confirm-children' })
}

const handleNotLoggedInUsers = (to, from, next) => {
  if (!store.getters['auth/userIsLoggedIn']) {
    if (isSecureRoute(to.name) || !isNotSecureRoute(to.name)) {
      return next({ name: 'login' })
    }
    return next()
  }
  next()
}

const handleLoggedInUsers = (to, from, next) => {
  if (store.getters['auth/userIsLoggedIn']) {
    if (!allows(to.name)) {
      if (store.getters['auth/role'] == 'nursery-super-admin') {
        return next({ name: 'bookings' })
      }
      if (store.getters['auth/role'] == 'nursery-admin') {
        return next({ name: 'dashboard' })
      }
      if (store.getters['auth/role'] == 'nursery-staff') {
        return next({ name: 'dashboard' })
      }
      return next({ name: 'home' })
    }
    return next()
  }
  next()
}

export default {
  serviceOnboarding,
  titleSetter,
  handleNotLoggedInUsers,
  confirmChildren,
  handleLoggedInUsers,
}
